import { SET_THEME } from '../actions/webConfiguretion';

const initialState = {
    theme: 'light'
};

export default (state = initialState, action) => {
    switch (action.type) {
        case SET_THEME: {
            return {
                ...state,
                theme: action.payload.theme
            };
        }

        default:
            return state;
    }
};
